import { call, put, takeLatest, select } from 'redux-saga/effects';
import { getProductScope } from '@discover-frontend/utils';
import {
  CREATE_TSV_REQUEST,
  CREATE_TSV_FAILURE,
  CREATE_TSV_SUCCESS,
  HIDE_CREATE_TSV_MODAL,
  GET_REPOSITORY_SUCCESS,
} from '../constants/action-types';
import translations from '../lang';
import { addToast } from '../actions';
import * as repositoryApi from '../services/repositoryApi';
import * as engineAffinityApi from '../services/engineAffinityApi';
import { catchableSagaFetch } from './SagaFetch';

function* fetchAndUpdateTsv(newAudience) {
  const response = yield catchableSagaFetch(repositoryApi.fetchRepositoryApi, {
    mode: 'tsv',
  });
  const currentData = yield select((state) => state.repository.data);
  yield put({
    type: GET_REPOSITORY_SUCCESS,
    response: {
      ...currentData,
      tsv: [
        newAudience.data,
        ...response.data.filter((d) => d.id !== newAudience.data.id),
      ],
    },
    total_count: response.total_count + 1,
  });
}

function* fetchCreateTsv(action) {
  try {
    const { file, name } = action;

    // get upload path
    const uploadPathResponse = yield catchableSagaFetch(
      engineAffinityApi.fetchGetTsvUploadFolderPathApi,
      name,
      'text/csv',
      getProductScope()
    );

    // upload file to S3
    const myHeaders = new Headers({ 'Content-Type': '' });
    const uploadResponse = yield call(fetch, uploadPathResponse.data.url, {
      method: 'PUT',
      headers: myHeaders,
      body: file,
    });

    if (!uploadResponse.ok) {
      throw Error(uploadResponse.statusText);
    }

    // create tsv
    const tsvResponse = yield catchableSagaFetch(
      engineAffinityApi.fetchCreateTsvApi,
      {
        filename: name,
        scope: getProductScope(),
      }
    );

    // create audience
    const audienceResponse = yield catchableSagaFetch(
      repositoryApi.fetchCreateAudienceApi,
      {
        label: name,
        query_type: 'tsv',
        base_query: { whole_population: true, query_block: null },
        target_membership_id: tsvResponse.data.membership_id,
        scope: getProductScope(),
      }
    );
    yield put({
      type: HIDE_CREATE_TSV_MODAL,
    });

    // show success modal
    yield put(
      addToast({
        status: 'success',
        message: translations['en-US'].TOASTS.CREATE_TSV,
      })
    );

    // retrieve new tsv list
    yield call(fetchAndUpdateTsv, audienceResponse);

    return yield put({
      type: CREATE_TSV_SUCCESS,
      membershipId: tsvResponse.data.membership_id,
      audienceId: audienceResponse.data.id,
    });
  } catch (error) {
    return yield put({
      type: CREATE_TSV_FAILURE,
      message: error.message || translations['en-US'].COMMON.GENERIC_ERROR,
    });
  }
}

export function* tsvActionWatcher() {
  yield takeLatest(CREATE_TSV_REQUEST, fetchCreateTsv);
}
